<template>
  <v-app id="main">
    <v-main>
      <AppBar />
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import AppBar from "@/components/layouts/AppBar.vue";
export default {
  name: "LandingLayout",
  components: {
    AppBar
  }
};
</script>

<style>
</style>